/* tslint:disable */

/* eslint-disable */

/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from "../runtime";

/**
 *
 * @export
 * @interface IngestionUpdateRequest
 */
export interface IngestionUpdateRequest {
  /**
   *
   * @type {string}
   * @memberof IngestionUpdateRequest
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof IngestionUpdateRequest
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof IngestionUpdateRequest
   */
  format?: string;
  /**
   *
   * @type {boolean}
   * @memberof IngestionUpdateRequest
   */
  processing?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof IngestionUpdateRequest
   */
  queued?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof IngestionUpdateRequest
   */
  cancelled?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof IngestionUpdateRequest
   */
  errored?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof IngestionUpdateRequest
   */
  archived?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof IngestionUpdateRequest
   */
  completed?: boolean;
  /**
   *
   * @type {string}
   * @memberof IngestionUpdateRequest
   */
  s3Bucket?: string;
  /**
   *
   * @type {string}
   * @memberof IngestionUpdateRequest
   */
  s3Key?: string;
  /**
   *
   * @type {number}
   * @memberof IngestionUpdateRequest
   */
  size?: number;
  /**
   *
   * @type {number}
   * @memberof IngestionUpdateRequest
   */
  progress?: number;
  /**
   *
   * @type {object}
   * @memberof IngestionUpdateRequest
   */
  error?: object;
  /**
   *
   * @type {string}
   * @memberof IngestionUpdateRequest
   */
  note?: string;
  /**
   *
   * @type {number}
   * @memberof IngestionUpdateRequest
   */
  startOffset?: number;
  /**
   *
   * @type {number}
   * @memberof IngestionUpdateRequest
   */
  endOffset?: number;
  /**
   *
   * @type {object}
   * @memberof IngestionUpdateRequest
   */
  meta?: object;
  /**
   *
   * @type {object}
   * @memberof IngestionUpdateRequest
   */
  context?: object;
  /**
   *
   * @type {Date}
   * @memberof IngestionUpdateRequest
   */
  deletedAt?: Date;
}

export function IngestionUpdateRequestFromJSON(
  json: any
): IngestionUpdateRequest {
  return IngestionUpdateRequestFromJSONTyped(json, false);
}

export function IngestionUpdateRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): IngestionUpdateRequest {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    status: !exists(json, "status") ? undefined : json["status"],
    name: !exists(json, "name") ? undefined : json["name"],
    format: !exists(json, "format") ? undefined : json["format"],
    processing: !exists(json, "processing") ? undefined : json["processing"],
    queued: !exists(json, "queued") ? undefined : json["queued"],
    cancelled: !exists(json, "cancelled") ? undefined : json["cancelled"],
    errored: !exists(json, "errored") ? undefined : json["errored"],
    archived: !exists(json, "archived") ? undefined : json["archived"],
    completed: !exists(json, "completed") ? undefined : json["completed"],
    s3Bucket: !exists(json, "s3_bucket") ? undefined : json["s3_bucket"],
    s3Key: !exists(json, "s3_key") ? undefined : json["s3_key"],
    size: !exists(json, "size") ? undefined : json["size"],
    progress: !exists(json, "progress") ? undefined : json["progress"],
    error: !exists(json, "error") ? undefined : json["error"],
    note: !exists(json, "note") ? undefined : json["note"],
    startOffset: !exists(json, "start_offset")
      ? undefined
      : json["start_offset"],
    endOffset: !exists(json, "end_offset") ? undefined : json["end_offset"],
    meta: !exists(json, "meta") ? undefined : json["meta"],
    context: !exists(json, "context") ? undefined : json["context"],
    deletedAt: !exists(json, "deleted_at")
      ? undefined
      : new Date(json["deleted_at"]),
  };
}

export function IngestionUpdateRequestToJSON(
  value?: IngestionUpdateRequest | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    status: value.status,
    name: value.name,
    format: value.format,
    processing: value.processing,
    queued: value.queued,
    cancelled: value.cancelled,
    errored: value.errored,
    archived: value.archived,
    completed: value.completed,
    s3_bucket: value.s3Bucket,
    s3_key: value.s3Key,
    size: value.size,
    progress: value.progress,
    error: value.error,
    note: value.note,
    start_offset: value.startOffset,
    end_offset: value.endOffset,
    meta: value.meta,
    context: value.context,
    deleted_at:
      value.deletedAt === undefined ? undefined : value.deletedAt.toISOString(),
  };
}
